import logo from "@/assets/images/logos/secondary-text.png";
import {useLocation} from "react-router";
import {Button} from "../ui/button";

export default function Header() {
    const location = useLocation();

    return (
        <header
            className="flex justify-center items-start sm:justify-between sm:items-center w-full px-3 sm:px-6 my-2">
            <a href="/" className="hidden sm:flex items-center space-x-3">
                <img src={logo} className="w-48 max-w-[75%]" alt=""/>
            </a>
            <nav className="py-2 space-x-4 text-sm font-medium">
                <a
                    href="/"
                    className={`font-semibold nav-link ${
                        location.pathname === "/" && "active"
                    }`}
                >
                    Home
                </a>

                <a
                    href="/agenda"
                    className={`font-semibold nav-link ${
                        location.pathname === "/agenda" && "active"
                    }`}
                >
                    Agenda
                </a>

                <a
                    href="/resources"
                    className={`font-semibold nav-link ${
                        location.pathname === "/resources" && "active"
                    }`}
                >
                    Resources
                </a>

                <a
                    href="https://luma.com/b50aslog"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Button size="sm" className="p-4">
                        <p className="font-semibold">Sign Up</p>
                    </Button>
                </a>

                {/*<a href="/events"*/}
                {/*   className={`font-semibold nav-link ${location.pathname === '/events' && 'active'}`}>Events</a>*/}
            </nav>
        </header>
    );
}
